import Logger, { EventName } from '@/wrappers/logger'

import { HTTP_ERRORS, HTTP_MESSAGE_ERRORS } from './constants'

/**
 * Set error message on store
 * - the method will clear the errors
 * - if dont have error but have customMessage, set the error message and return
 * - if dont have the response will be a http client error
 * - if the error has status >= 500 will be a server error, setCritical error
 * - otherwise get the error mesage based on http error or custom message and set the error
 * @param {Object} params: optional
 * - error (object): the error object if have one
 * - context (string): the context object if you are using  the HComponentHandler
 * - request (string): the error request origin
 * - message (string): custom message
 * @returns
 */
const setError = async (store, { error, context, request, message }) => {
  store.commit('setCriticalError', null)

  if (!error) {
    store.commit('setError', null)
    if (message) store.commit('setError', message)
    return
  }

  if (!error.response) {
    setClientHttpError({ error, request, store, context })
    return
  }

  if (error.response?.status >= 500 && context) {
    store.dispatch('setCriticalError', { type: 'server', context })
    return
  }

  const errorMessage = await getErrorMessage({ error, message })

  store.commit('setError', errorMessage)
}

/**
 * Set critical error if have context, otherwise set the comun error
 * @param {Object} params:
 * - context (string): the context of the error
 * - type (string): error type
 * @returns
 */
const setCriticalError = (store, { context, type }) => {
  return store.commit('setCriticalError', {
    type,
    context
  })
}

const setClientHttpError = ({ error, request, store, context }) => {
  const errorName = error.name?.toLowerCase()

  if (errorName === 'axioserror' && error.message?.includes('timeout')) {
    Logger.addLog(EventName.TIMEOUT_ERROR, {
      data: {
        context,
        action: request
      }
    })
    return store.dispatch('setCriticalError', {
      type: 'timeout_error',
      context
    })
  }
  if (errorName === 'cancelederror') {
    //User abort the request
    return
  }
  /* eslint-disable no-console */
  console.error(error)
}

const getErrorMessage = ({ error, message }) => {
  const response = error.response

  if (message) {
    return message
  }

  if (response.data?.message && HTTP_MESSAGE_ERRORS[response.data?.message]) {
    return HTTP_MESSAGE_ERRORS[response.data?.message]
  }
  return `{ ERR.${response.status} }
            ${
              HTTP_ERRORS[response?.data?.code?.toLowerCase()] ||
              'Desculpe, não foi possível completar a operação'
            }`
}

const clearError = store => {
  store.commit('setError', null)
}

export default {
  setError,
  setCriticalError,
  clearError
}
